export const hasDirty = (v: unknown): boolean => {
  if (!v) return false;
  if (v === true) return true;
  if (Array.isArray(v)) return v.some(hasDirty);
  if (typeof v !== "object") return false;
  return Object.values(v as Record<string, unknown>).some(hasDirty);
};

export const hasValue = (v: unknown): boolean => {
  if (v === null || v === undefined) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (typeof v === "number") return true;
  if (typeof v === "boolean") return true;
  if (Array.isArray(v)) return v.some(hasValue);
  if (typeof v !== "object") return false;
  return Object.values(v as Record<string, unknown>).some(hasValue);
};
